var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74286 23.7367V11.1429C2.74286 6.50367 6.50366 2.74286 11.1429 2.74286C15.782 2.74286 19.5429 6.50367 19.5429 11.1429V18.5143H22.2857V11.1429C22.2857 4.98883 17.2969 0 11.1429 0C4.98883 0 0 4.98883 0 11.1429V30.6857C0 33.8063 1.2828 36.6273 3.34984 38.6501C5.37266 40.7172 8.19367 42 11.3143 42H30.8571C37.0112 42 42 37.0112 42 30.8571C42 24.7031 37.0112 19.7143 30.8571 19.7143H11.3143C7.86782 19.7143 4.78681 21.279 2.74286 23.7367ZM18.2633 39.2571C20.721 37.2132 22.2857 34.1322 22.2857 30.6857V23.6571H19.5429V30.6857C19.5429 35.3249 15.782 39.0857 11.1429 39.0857C8.86686 39.0857 6.80228 38.1805 5.28948 36.7105C3.81947 35.1977 2.91429 33.1331 2.91429 30.8571C2.91429 26.218 6.67509 22.4571 11.3143 22.4571H30.8571C35.4963 22.4571 39.2571 26.218 39.2571 30.8571C39.2571 35.4963 35.4963 39.2571 30.8571 39.2571H18.2633Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.8e15cd5adb636e57f2f883b492ae68fa.svg";
export { ForwardRef as ReactComponent };